(function ($) {
    /**
     *копирование ссылки в буфер обмена
     */
    $.fn.copyingLink = function () {
        var $self = $(this);
        var $button = $self.find('.js-copy-btn');
        var link = $button.data('href');
        var tooltip = '<div class="tooltip js-tooltip">Ссылка скопирована</div>';
        var flag = false;
        /**
         *инициализация
         */
        var init = function () {
            $button.on('click', function () {
                var $temp = $('<input>');
                $('body').append($temp);
                $temp.val(link).select();
                document.execCommand('copy');
                $temp.remove();
                if (flag) {
                    return;
                }
                showTooltip();
                setTimeout(removeTooltip, 2000);
            });
        };
        /**
         *показать тултип
         */
        var showTooltip = function () {
            $button.append(tooltip);
            var $tooltipElement = $button.find('.js-tooltip');
            $tooltipElement.fadeToggle();
            flag = true;
        };
        /**
         *удалить тултип
         */
        var removeTooltip = function () {
            var $tooltipElement = $button.find('.js-tooltip');
            $tooltipElement.fadeToggle();
            setTimeout( function () {
                $tooltipElement.remove();
                flag = false;
            }, 2000);
        };

        init();

        return this;
    };

    $('.js-copy-wrapper').each(function () {
        $(this).data('copyingLink', $(this).copyingLink());
    });
})(jQuery);
